<template>
  <div class="countContainer">
    <button :disabled="disabled || time > 0" class="btn">{{ text }}</button>
  </div>
</template>

<script>
export default {
  name: "Code",
  props: {
    second: {
      type: Number,
      default: 60,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      time: 0,
    };
  },
  methods: {
    run: function () {
      this.time = this.second;
      this.timer();
    },
    timer: function () {
      if (this.time > 0) {
        this.time--;
        setTimeout(this.timer, 1000);
      }
    },
  },
  computed: {
    text: function () {
      return this.time > 0 ? this.time + "s" : this.$t("获取验证码");
    },
  },
};
</script>

<style scoped>
.countContainer {
  display: inline-block;
}
.btn {
  background: none;
  color: #1e86db;
}
</style>
